import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderVideo() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 2,
                        spaceBetween: 90,
                    },
                    '@1.50': {
                        slidesPerView: 2,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/EmfTgqvu54w?si=FuTFfEgmkcwOCysf" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="tie-fluid-width-video-wrapper" style={{ paddingTop: '' }}>
                        <iframe width={560} height={315} src="https://www.youtube.com/embed/zy4UpFvAXUk?si=BaosvdEDybI09Xm7" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                </SwiperSlide>




            </Swiper>
        </>
    );
}
